// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.bs.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Menu = require("@expln/utils/src/main/react-mui-components/Expln_React_Menu.bs.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var MM_cmp_search_asrt = require("./MM_cmp_search_asrt.bs.js");
var MM_wrk_editor_json = require("../test/MM_wrk_editor_json.bs.js");
var Static_XML_to_HTML = require("../utils/Static_XML_to_HTML.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var MM_cmp_export_proof = require("./MM_cmp_export_proof.bs.js");
var MM_cmp_substitution = require("./MM_cmp_substitution.bs.js");
var XML_formatting_help = require("../utils/XML_formatting_help.bs.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_multiline_text = require("./MM_cmp_multiline_text.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var MM_cmp_merge_two_stmts = require("./MM_cmp_merge_two_stmts.bs.js");
var MM_cmp_save_or_discard = require("./MM_cmp_save_or_discard.bs.js");
var MM_cmp_unify_bottom_up = require("./MM_cmp_unify_bottom_up.bs.js");
var Add = require("@mui/icons-material/Add").default;
var Hub = require("@mui/icons-material/Hub").default;
var MM_cmp_import_from_json = require("./MM_cmp_import_from_json.bs.js");
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var Search = require("@mui/icons-material/Search").default;
var MM_cmp_export_state_to_url = require("./MM_cmp_export_state_to_url.bs.js");
var MM_cmp_export_state_to_json = require("./MM_cmp_export_state_to_json.bs.js");
var MergeType = require("@mui/icons-material/MergeType").default;
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var Expln_React_ContentWithStickyHeader = require("@expln/utils/src/main/react-components/Expln_React_ContentWithStickyHeader.bs.js");
var TextRotationNone = require("@mui/icons-material/TextRotationNone").default;
var ControlPointDuplicate = require("@mui/icons-material/ControlPointDuplicate").default;

var unifyAllIsRequiredCnt = {
  contents: 0
};

function editorSaveStateToLocStor(state, key) {
  Local_storage_utils.locStorWriteString(key, Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)));
}

function readEditorStateFromLocStor(key) {
  var stateLocStorStr = Local_storage_utils.locStorReadString(key);
  if (stateLocStorStr !== undefined) {
    return Belt_Result.mapWithDefault(MM_wrk_editor_json.readEditorStateFromJsonStr(stateLocStorStr), undefined, (function (state) {
                  return state;
                }));
  }
  
}

function rndIconButton(icon, onClick, active, ref, title, param) {
  var tmp = {};
  if (ref !== undefined) {
    tmp.ref = Caml_option.valFromOption(ref);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement("span", tmp, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: "primary",
                  disabled: !active,
                  children: icon
                }));
}

var stateLocStorKey = "editor-state";

var lastUsedAsrtSearchTypLocStorKey = "search-asrt-typ";

function saveLastUsedTyp(ctx, typInt) {
  var typStr = MM_context.ctxIntToSym(ctx, typInt);
  if (typStr !== undefined) {
    localStorage.setItem(lastUsedAsrtSearchTypLocStorKey, typStr);
    return ;
  }
  
}

function getLastUsedTyp(ctx) {
  var typStr = localStorage.getItem(lastUsedAsrtSearchTypLocStorKey);
  if (typStr !== null) {
    return MM_context.ctxSymToInt(ctx, typStr);
  }
  
}

function MM_cmp_editor(Props) {
  var modalRef = Props.modalRef;
  var settingsV = Props.settingsV;
  var settings = Props.settings;
  var srcs = Props.srcs;
  var preCtxV = Props.preCtxV;
  var preCtx = Props.preCtx;
  var top = Props.top;
  var reloadCtx = Props.reloadCtx;
  var initialStateSafeBase64 = Props.initialStateSafeBase64;
  var match = React.useState(function () {
        return MM_wrk_editor_json.createInitialEditorState(settingsV, settings, preCtxV, preCtx, readEditorStateFromLocStor(stateLocStorKey));
      });
  var setStatePriv = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setMainMenuIsOpened = match$1[1];
  var mainMenuIsOpened = match$1[0];
  var mainMenuButtonRef = React.useRef(null);
  var setState = function (update) {
    Curry._1(setStatePriv, (function (st) {
            var st$1 = MM_wrk_editor.updateEditorStateWithPostupdateActions(st, update);
            editorSaveStateToLocStor(st$1, stateLocStorKey);
            return st$1;
          }));
  };
  var editIsActive = state.varsEditMode || state.disjEditMode || state.stmts.some(function (stmt) {
        if (stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
          return true;
        } else {
          return stmt.jstfEditMode;
        }
      });
  var thereAreSyntaxErrors = MM_wrk_editor.editorStateHasErrors(state);
  var atLeastOneStmtIsChecked = state.checkedStmtIds.length !== 0;
  var atLeastOneStmtIsNotChecked = state.stmts.length !== state.checkedStmtIds.length;
  var mainCheckboxState = atLeastOneStmtIsChecked && atLeastOneStmtIsNotChecked ? undefined : (
      atLeastOneStmtIsChecked && !atLeastOneStmtIsNotChecked ? true : false
    );
  var generalModificationActionIsEnabled = !editIsActive && !thereAreSyntaxErrors;
  var atLeastOneStmtIsSelected = Belt_Option.getWithDefault(mainCheckboxState, true);
  var stmt = MM_wrk_editor.getTheOnlySelectedStmt(state);
  var singleProvableSelected = stmt !== undefined && stmt.typ === /* P */1 ? stmt : undefined;
  var oneStatementIsSelected = state.checkedStmtIds.length === 1;
  var actSettingsUpdated = function (settingsV, settings) {
    setState(function (__x) {
          return MM_wrk_editor.setSettings(__x, settingsV, settings);
        });
  };
  React.useEffect((function () {
          actSettingsUpdated(settingsV, settings);
        }), [settingsV]);
  var actPreCtxUpdated = function (srcs, preCtxV, preCtx) {
    setState(function (__x) {
          return MM_wrk_editor.setPreCtx(__x, srcs, preCtxV, preCtx);
        });
  };
  React.useEffect((function () {
          actPreCtxUpdated(srcs, preCtxV, preCtx);
        }), [preCtxV]);
  var actOpenMainMenu = function (param) {
    Curry._1(setMainMenuIsOpened, (function (param) {
            return true;
          }));
  };
  var actCloseMainMenu = function (param) {
    Curry._1(setMainMenuIsOpened, (function (param) {
            return false;
          }));
  };
  var actAddNewStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.addNewStmt(st)[0];
        });
  };
  var actDeleteCheckedStmts = function (param) {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    var numOfSelectedStmts = state.checkedStmtIds.length;
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: React.createElement(Expln_React_Column.make, {
                                      spacing: 1,
                                      children: null
                                    }, numOfSelectedStmts === state.stmts.length ? "Delete all statements?" : (
                                        numOfSelectedStmts === 1 ? "Delete the selected statement?" : "Delete " + String(state.checkedStmtIds.length) + " selected statements?"
                                      ), React.createElement(Expln_React_Row.make, {
                                          children: null
                                        }, React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              children: "Cancel"
                                            }), React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                  setState(MM_wrk_editor.deleteCheckedStmts);
                                                }),
                                              variant: "contained",
                                              children: "Delete"
                                            })))
                              });
                  }));
          }));
  };
  var actMoveCheckedStmtsUp = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, true);
        });
  };
  var actMoveCheckedStmtsDown = function (param) {
    setState(function (__x) {
          return MM_wrk_editor.moveCheckedStmts(__x, false);
        });
  };
  var actDuplicateStmt = function (param) {
    setState(function (st) {
          return MM_wrk_editor.uncheckAllStmts(MM_wrk_editor.duplicateCheckedStmt(st));
        });
  };
  var actBeginEdit0 = function (setter) {
    if (!editIsActive) {
      return setState(setter);
    }
    
  };
  var actBeginEdit = function (setter, stmtId) {
    if (!editIsActive) {
      return setState(function (__x) {
                  return Curry._2(setter, __x, stmtId);
                });
    }
    
  };
  var actCompleteEditLabel = function (stmtId, newLabel) {
    var newLabel$1 = newLabel.trim();
    var msg = MM_wrk_editor.renameStmt(state, stmtId, newLabel$1);
    if (msg.TAG !== /* Ok */0) {
      return MM_react_common.openInfoDialog(modalRef, "Cannot rename this statement: " + msg._0 + "", undefined, undefined);
    }
    var st = msg._0;
    setState(function (param) {
          return MM_wrk_editor.completeLabelEditMode(st, stmtId, newLabel$1);
        });
  };
  var actMergeTwoStmts = function (param) {
    var msg = MM_wrk_editor.findStmtsToMerge(state);
    if (msg.TAG !== /* Ok */0) {
      return MM_react_common.openInfoDialog(modalRef, msg._0, undefined, undefined);
    }
    var match = msg._0;
    var stmt2 = match[1];
    var stmt1 = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_merge_two_stmts.make, {
                                stmt1: stmt1,
                                stmt2: stmt2,
                                onCancel: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onStmtSelected: (function (stmtToUse, stmtToRemove) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          var st$1 = MM_wrk_editor.mergeStmts(st, stmtToUse.id, stmtToRemove.id);
                                          if (st$1.TAG === /* Ok */0) {
                                            return MM_wrk_editor.uncheckAllStmts(st$1._0);
                                          }
                                          MM_react_common.openInfoDialog(modalRef, st$1._0, undefined, undefined);
                                          return st;
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actSearchAsrt = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_search_asrt.make, {
                                modalRef: modalRef,
                                settingsVer: state.settingsV,
                                settings: state.settings,
                                preCtxVer: state.preCtxV,
                                preCtx: state.preCtx,
                                varsText: state.varsText,
                                disjText: state.disjText,
                                wrkCtx: wrkCtx$1,
                                frms: state.frms,
                                initialTyp: getLastUsedTyp(state.preCtx),
                                onTypChange: (function (__x) {
                                    saveLastUsedTyp(state.preCtx, __x);
                                  }),
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onResultsSelected: (function (selectedResults) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return selectedResults.reduce(MM_wrk_editor.addNewStatements, st);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actSubstitute = function (param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var expr1Init;
    if (state.checkedStmtIds.length >= 1) {
      var id = Caml_array.get(state.checkedStmtIds, 0);
      expr1Init = Belt_Option.map(Caml_option.undefined_to_opt(state.stmts.find(function (stmt) {
                    return stmt.id === id;
                  })), (function (stmt) {
              return MM_wrk_editor.contToStr(stmt.cont);
            }));
    } else {
      expr1Init = undefined;
    }
    var expr2Init;
    if (state.checkedStmtIds.length >= 2) {
      var id$1 = Caml_array.get(state.checkedStmtIds, 1);
      expr2Init = Belt_Option.map(Caml_option.undefined_to_opt(state.stmts.find(function (stmt) {
                    return stmt.id === id$1;
                  })), (function (stmt) {
              return MM_wrk_editor.contToStr(stmt.cont);
            }));
    } else {
      expr2Init = undefined;
    }
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(MM_cmp_substitution.make, {
                                modalRef: modalRef,
                                editorState: state,
                                expr1Init: expr1Init,
                                expr2Init: expr2Init,
                                wrkCtx: wrkCtx$1,
                                onCanceled: (function (param) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onSubstitutionSelected: (function (wrkSubs) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return MM_wrk_editor.applySubstitutionForEditor(st, wrkSubs);
                                        });
                                  })
                              });
                  }));
          }));
  };
  var makeActTerminate = function (modalId, param) {
    MM_wrk_client.terminateWorker(undefined);
    Expln_React_Modal.closeModal(modalRef, modalId);
  };
  var prepareArgs0 = function (argLabels, rootStmts) {
    return rootStmts.filter(function (stmt) {
                  return argLabels.includes(stmt.label);
                }).map(function (stmt) {
                return stmt.expr;
              });
  };
  var getArgs0AndAsrtLabel = function (jstfText, rootStmts) {
    var match = MM_wrk_editor.parseJstf(jstfText);
    if (match.TAG !== /* Ok */0) {
      return ;
    }
    var match$1 = match._0;
    if (match$1 !== undefined) {
      return [
              prepareArgs0(match$1.args, rootStmts),
              match$1.label
            ];
    }
    
  };
  var actUnify = function (stmtId, params, initialDebugLevel, param) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var varsText = state.varsText;
    var disjText = state.disjText;
    var state$1;
    if (stmtId !== undefined) {
      var state$2 = MM_wrk_editor.uncheckAllStmts(state);
      state$1 = MM_wrk_editor.toggleStmtChecked(state$2, stmtId);
    } else {
      state$1 = state;
    }
    var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(state$1);
    var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
    var stmt = MM_wrk_editor.getTheOnlySelectedStmt(state$1);
    var singleProvableSelected = stmt !== undefined && stmt.typ === /* P */1 ? stmt : undefined;
    if (singleProvableSelected !== undefined) {
      var initialParams;
      if (params !== undefined) {
        initialParams = params;
      } else {
        var match = getArgs0AndAsrtLabel(singleProvableSelected.jstfText, rootStmts);
        initialParams = match !== undefined ? MM_provers.bottomUpProverParamsMake(match[1], undefined, undefined, undefined, undefined, undefined, match[0], undefined, undefined, undefined) : undefined;
      }
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                  return null;
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                      var tmp = {
                        modalRef: modalRef,
                        settingsVer: state$1.settingsV,
                        settings: state$1.settings,
                        preCtxVer: state$1.preCtxV,
                        preCtx: state$1.preCtx,
                        frms: state$1.frms,
                        parenCnt: state$1.parenCnt,
                        varsText: varsText,
                        disjText: disjText,
                        wrkCtx: wrkCtx$1,
                        rootStmts: rootUserStmts,
                        reservedLabels: state$1.stmts.map(function (stmt) {
                              return stmt.label;
                            }),
                        typeToPrefix: Belt_MapString.fromArray(state$1.settings.typeSettings.map(function (ts) {
                                  return [
                                          ts.typ,
                                          ts.prefix
                                        ];
                                })),
                        onResultSelected: (function (newStmtsDto) {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                            setState(function (st) {
                                  var st$1 = MM_wrk_editor.addNewStatements(st, newStmtsDto);
                                  return MM_wrk_editor.incUnifyAllIsRequiredCnt(MM_wrk_editor.uncheckAllStmts(st$1));
                                });
                          }),
                        onCancel: (function (param) {
                            Expln_React_Modal.closeModal(modalRef, modalId);
                          })
                      };
                      if (initialParams !== undefined) {
                        tmp.initialParams = Caml_option.valFromOption(initialParams);
                      }
                      if (initialDebugLevel !== undefined) {
                        tmp.initialDebugLevel = initialDebugLevel;
                      }
                      return React.createElement(MM_cmp_unify_bottom_up.make, tmp);
                    }));
            }));
      return ;
    }
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return MM_react_common.rndProgress("Unifying all", 0, undefined, undefined);
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return MM_react_common.rndProgress("Unifying all", 0, (function (param) {
                                  return makeActTerminate(modalId, param);
                                }), undefined);
                  }));
            return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(state$1.settingsV, state$1.settings, state$1.preCtxV, state$1.preCtx, varsText, disjText, rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt), undefined, 0, (function (msg) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                      return MM_react_common.rndProgress(msg, undefined, (function (param) {
                                                    return makeActTerminate(modalId, param);
                                                  }), undefined);
                                    }));
                            })), (function (proofTreeDto) {
                          Expln_React_Modal.closeModal(modalRef, modalId);
                          Curry._1(setStatePriv, (function (st) {
                                  var st$1 = MM_wrk_editor.applyUnifyAllResults(st, proofTreeDto);
                                  editorSaveStateToLocStor(st$1, stateLocStorKey);
                                  return st$1;
                                }));
                        }));
          }));
  };
  React.useEffect((function () {
          if (unifyAllIsRequiredCnt.contents < state.unifyAllIsRequiredCnt) {
            unifyAllIsRequiredCnt.contents = state.unifyAllIsRequiredCnt;
            if (!MM_wrk_editor.editorStateHasErrors(state)) {
              actUnify(undefined, undefined, undefined, undefined);
            }
            
          }
          
        }), [state.unifyAllIsRequiredCnt]);
  var rndSrcDtos = function (srcs) {
    return React.createElement(Expln_React_Column.make, {
                children: srcs.map(function (src, i) {
                      var readInstr = MM_wrk_editor.readInstrFromStr(src.readInstr);
                      var tmp;
                      if (readInstr === /* ReadAll */0) {
                        tmp = "read all";
                      } else {
                        var readInstrStr = readInstr === /* StopBefore */1 ? "stop before" : "stop after";
                        tmp = "" + readInstrStr + ": " + src.label + "";
                      }
                      return React.createElement(Paper, {
                                  style: {
                                    padding: "3px"
                                  },
                                  children: React.createElement(Expln_React_Column.make, {
                                        children: null
                                      }, src.url, tmp),
                                  key: String(i)
                                });
                    })
              });
  };
  var actImportFromJson = function (jsonStr) {
    var errorMsg = MM_wrk_editor_json.readEditorStateFromJsonStr(jsonStr);
    if (errorMsg.TAG === /* Ok */0) {
      var stateLocStor = errorMsg._0;
      setState(function (param) {
            return MM_wrk_editor_json.createInitialEditorState(settingsV, settings, preCtxV, preCtx, stateLocStor);
          });
      Belt_Option.map(Caml_option.nullable_to_opt(reloadCtx.current), (function (reloadCtx) {
              return Expln_utils_promise.promiseMap(Curry._1(reloadCtx, stateLocStor.srcs), (function (res) {
                            if (res.TAG === /* Ok */0) {
                              return ;
                            }
                            var msg = res._0;
                            Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                        return null;
                                      })), (function (modalId) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                            return React.createElement(Paper, {
                                                        style: {
                                                          padding: "10px"
                                                        },
                                                        children: React.createElement(Expln_React_Column.make, {
                                                              spacing: 1,
                                                              children: null
                                                            }, React.createElement("span", {
                                                                  style: {
                                                                    fontWeight: "bold"
                                                                  }
                                                                }, "Could not realod the context because of the error:"), React.createElement("span", {
                                                                  style: {
                                                                    color: "red"
                                                                  }
                                                                }, msg), React.createElement("span", undefined, "This error happened when loading the context:"), rndSrcDtos(stateLocStor.srcs), React.createElement(Button, {
                                                                  onClick: (function (param) {
                                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    }),
                                                                  variant: "contained",
                                                                  children: "Ok"
                                                                }))
                                                      });
                                          }));
                                  }));
                          }));
            }));
      return true;
    }
    var errorMsg$1 = errorMsg._0;
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: React.createElement(Expln_React_Column.make, {
                                      spacing: 1,
                                      children: null
                                    }, errorMsg$1, React.createElement(Button, {
                                          onClick: (function (param) {
                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                            }),
                                          variant: "contained",
                                          children: "Ok"
                                        }))
                              });
                  }));
          }));
    return false;
  };
  React.useEffect((function () {
          if (initialStateSafeBase64 !== undefined) {
            actImportFromJson(atob(initialStateSafeBase64.replace(/-/g, "+").replace(/_/g, "/")));
          }
          
        }), []);
  var rndError = function (msgOpt, color) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: color
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndMainMenu = function (param) {
    if (!mainMenuIsOpened) {
      return null;
    }
    var mainMenuButtonRef$1 = mainMenuButtonRef.current;
    if (mainMenuButtonRef$1 == null) {
      return null;
    } else {
      return React.createElement(Expln_React_Menu.make, {
                  opn: true,
                  anchorEl: mainMenuButtonRef$1,
                  onClose: actCloseMainMenu,
                  children: null
                }, React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                      return null;
                                    })), (function (modalId) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                          return React.createElement(MM_cmp_export_state_to_url.make, {
                                                      editoStateBase64: btoa(Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state))),
                                                      onClose: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        })
                                                    });
                                        }));
                                }));
                        }),
                      children: "Export to URL"
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                      return null;
                                    })), (function (modalId) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                          return React.createElement(MM_cmp_export_state_to_json.make, {
                                                      jsonStr: Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)),
                                                      onClose: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        })
                                                    });
                                        }));
                                }));
                        }),
                      children: "Export to JSON"
                    }), React.createElement(MenuItem, {
                      onClick: (function (param) {
                          Curry._1(setMainMenuIsOpened, (function (param) {
                                  return false;
                                }));
                          Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                      return null;
                                    })), (function (modalId) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                          return React.createElement(MM_cmp_import_from_json.make, {
                                                      onImport: (function (text) {
                                                          if (actImportFromJson(text)) {
                                                            return Expln_React_Modal.closeModal(modalRef, modalId);
                                                          }
                                                          
                                                        }),
                                                      onCancel: (function (param) {
                                                          Expln_React_Modal.closeModal(modalRef, modalId);
                                                        })
                                                    });
                                        }));
                                }));
                        }),
                      children: "Import from JSON ..."
                    }));
    }
  };
  var rndButtons = function (param) {
    return React.createElement(Paper, {
                children: React.createElement(Expln_React_Row.make, {
                      childXsOffset: (function (idx) {
                          if (idx !== 10) {
                            return ;
                          } else {
                            return "auto";
                          }
                        }),
                      children: null
                    }, React.createElement(Checkbox, {
                          disabled: editIsActive,
                          indeterminate: Belt_Option.isNone(mainCheckboxState),
                          checked: Belt_Option.getWithDefault(mainCheckboxState, false),
                          onChange: (function (param) {
                              var action = mainCheckboxState !== undefined && !mainCheckboxState ? MM_wrk_editor.checkAllStmts : MM_wrk_editor.uncheckAllStmts;
                              Curry._1(setStatePriv, (function (st) {
                                      var st$1 = Curry._1(action, st);
                                      editorSaveStateToLocStor(st$1, stateLocStorKey);
                                      return st$1;
                                    }));
                            })
                        }), rndIconButton(React.createElement(ArrowDownward, {}), actMoveCheckedStmtsDown, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, false), undefined, "Move selected statements down", undefined), rndIconButton(React.createElement(ArrowUpward, {}), actMoveCheckedStmtsUp, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, true), undefined, "Move selected statements up", undefined), rndIconButton(React.createElement(Add, {}), actAddNewStmt, !editIsActive, undefined, "Add new statement (and place before selected statements if any)", undefined), rndIconButton(React.createElement(DeleteForever, {}), actDeleteCheckedStmts, !editIsActive && atLeastOneStmtIsSelected, undefined, "Delete selected statements", undefined), rndIconButton(React.createElement(ControlPointDuplicate, {}), actDuplicateStmt, !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), undefined, "Duplicate selected statement", undefined), rndIconButton(React.createElement(MergeType, {
                              style: {
                                transform: "rotate(180deg)"
                              }
                            }), actMergeTwoStmts, oneStatementIsSelected, undefined, "Merge two similar statements", undefined), rndIconButton(React.createElement(Search, {}), actSearchAsrt, generalModificationActionIsEnabled && Belt_MapString.size(state.frms) > 0, undefined, "Add new statements from existing assertions (and place before selected statements if any)", undefined), rndIconButton(React.createElement(TextRotationNone, {}), actSubstitute, generalModificationActionIsEnabled && state.checkedStmtIds.length <= 2, undefined, "Apply a substitution to all statements", undefined), rndIconButton(React.createElement(Hub, {}), (function (param) {
                            actUnify(undefined, undefined, undefined, undefined);
                          }), generalModificationActionIsEnabled && (!atLeastOneStmtIsSelected || Belt_Option.isSome(singleProvableSelected)) && state.stmts.length > 0, undefined, "Unify all statements or unify selected provable bottom-up", undefined), rndIconButton(React.createElement(Menu, {}), actOpenMainMenu, !editIsActive, Caml_option.some(mainMenuButtonRef), "Additional actions", undefined))
              });
  };
  var rndStmt = function (stmt) {
    return React.createElement("tr", {
                key: stmt.id
              }, React.createElement("td", undefined, React.createElement(Checkbox, {
                        style: {
                          margin: "-7px 0px"
                        },
                        disabled: editIsActive,
                        checked: MM_wrk_editor.isStmtChecked(state, stmt.id),
                        onChange: (function (param) {
                            var id = stmt.id;
                            Curry._1(setStatePriv, (function (st) {
                                    var st$1 = MM_wrk_editor.toggleStmtChecked(st, id);
                                    editorSaveStateToLocStor(st$1, stateLocStorKey);
                                    return st$1;
                                  }));
                          })
                      })), React.createElement("td", undefined, React.createElement(MM_cmp_user_stmt.make, {
                        stmt: stmt,
                        onLabelEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setLabelEditMode, stmt.id);
                          }),
                        onLabelEditDone: (function (newLabel) {
                            actCompleteEditLabel(stmt.id, newLabel);
                          }),
                        onLabelEditCancel: (function (newLabel) {
                            var stmtId = stmt.id;
                            var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                            if (stmt$1 === undefined) {
                              return ;
                            }
                            var textOld = stmt$1.label;
                            if (textOld === newLabel || newLabel === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: textOld,
                                                          contNew: newLabel,
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              actCompleteEditLabel(stmtId, newLabel);
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        onTypEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setTypEditMode, stmt.id);
                          }),
                        onTypEditDone: (function (newTyp) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeTypEditMode(__x, stmt.id, newTyp);
                                });
                          }),
                        onContEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setContEditMode, stmt.id);
                          }),
                        onContEditDone: (function (newContText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeContEditMode(__x, stmt.id, newContText);
                                });
                          }),
                        onContEditCancel: (function (newContText) {
                            var stmtId = stmt.id;
                            var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                            if (stmt$1 === undefined) {
                              return ;
                            }
                            var contOld = stmt$1.cont;
                            var contNew = MM_wrk_editor.strToCont(newContText, undefined, undefined, undefined);
                            var textOld = MM_wrk_editor.contToStr(contOld);
                            var textNew = MM_wrk_editor.contToStr(contNew);
                            if (textOld === textNew) {
                              if (textOld === "") {
                                return setState(function (__x) {
                                            return MM_wrk_editor.deleteStmt(__x, stmtId);
                                          });
                              } else {
                                return setState(function (__x) {
                                            return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                          });
                              }
                            } else if (textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: MM_cmp_user_stmt.rndContText(contOld),
                                                          removeStmt: textOld === "",
                                                          contNew: MM_cmp_user_stmt.rndContText(contNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              if (textOld === "") {
                                                                return setState(function (__x) {
                                                                            return MM_wrk_editor.deleteStmt(__x, stmtId);
                                                                          });
                                                              } else {
                                                                return setState(function (__x) {
                                                                            return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                                                          });
                                                              }
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        onJstfEditRequested: (function (param) {
                            actBeginEdit(MM_wrk_editor.setJstfEditMode, stmt.id);
                          }),
                        onJstfEditDone: (function (newJstf) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeJstfEditMode(__x, stmt.id, newJstf);
                                });
                          }),
                        onJstfEditCancel: (function (newJstf) {
                            var stmtId = stmt.id;
                            var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                            if (stmt$1 === undefined) {
                              return ;
                            }
                            var textOld = stmt$1.jstfText.trim();
                            var textNew = newJstf.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: textOld,
                                                          contNew: textNew,
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        onGenerateProof: (function (param) {
                            var stmtId = stmt.id;
                            var match = MM_wrk_editor.generateCompressedProof(state, stmtId);
                            if (match === undefined) {
                              return ;
                            }
                            var proofTableWithoutTypes = match[2];
                            var proofTableWithTypes = match[1];
                            var proofText = match[0];
                            Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                        return null;
                                      })), (function (modalId) {
                                    Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                            return React.createElement(MM_cmp_export_proof.make, {
                                                        proofText: proofText,
                                                        proofTableWithTypes: proofTableWithTypes,
                                                        proofTableWithoutTypes: proofTableWithoutTypes,
                                                        onClose: (function (param) {
                                                            Expln_React_Modal.closeModal(modalRef, modalId);
                                                          })
                                                      });
                                          }));
                                  }));
                          }),
                        onDebug: (function (param) {
                            var stmtId = stmt.id;
                            var st = MM_wrk_editor.uncheckAllStmts(state);
                            var st$1 = MM_wrk_editor.toggleStmtChecked(st, stmtId);
                            var stmt$1 = MM_wrk_editor.getTheOnlySelectedStmt(st$1);
                            var provableSelected = stmt$1 !== undefined && stmt$1.typ === /* P */1 ? stmt$1 : undefined;
                            if (provableSelected === undefined) {
                              return ;
                            }
                            var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(st$1);
                            var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
                            var match = getArgs0AndAsrtLabel(provableSelected.jstfText, rootStmts);
                            var params = match !== undefined ? MM_provers.bottomUpProverParamsMake(match[1], 1, /* Less */2, false, false, false, match[0], [], undefined, undefined) : MM_provers.bottomUpProverParamsMake(undefined, 1, /* Less */2, false, false, false, rootStmts.map(function (stmt) {
                                        return stmt.expr;
                                      }), [], undefined, undefined);
                            actUnify(stmtId, params, Belt_Option.isSome(params.asrtLabel) ? 2 : 1, undefined);
                          })
                      }), rndError(stmt.stmtErr, "red"), rndError(stmt.unifErr, "darkgrey")));
  };
  var rndDescr = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "7px",
                  marginLeft: "7px"
                },
                children: null
              }, "Description", React.createElement(Expln_React_Column.make, {
                    children: React.createElement(MM_cmp_multiline_text.make, {
                          text: state.descr,
                          editMode: state.descrEditMode,
                          onEditRequested: (function (param) {
                              actBeginEdit0(MM_wrk_editor.setDescrEditMode);
                            }),
                          onEditDone: (function (newText) {
                              setState(function (__x) {
                                    return MM_wrk_editor.completeDescrEditMode(__x, newText);
                                  });
                            }),
                          onEditCancel: (function (newText) {
                              var textOld = state.descr.trim();
                              var textNew = newText.trim();
                              if (textOld === textNew || textNew === "") {
                                return setState(function (__x) {
                                            return MM_wrk_editor.completeDescrEditMode(__x, textOld);
                                          });
                              } else {
                                Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                            return null;
                                          })), (function (modalId) {
                                        Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                return React.createElement(MM_cmp_save_or_discard.make, {
                                                            contOld: React.createElement("pre", undefined, textOld),
                                                            contNew: React.createElement("pre", undefined, textNew),
                                                            onDiscard: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                                setState(function (__x) {
                                                                      return MM_wrk_editor.completeDescrEditMode(__x, textOld);
                                                                    });
                                                              }),
                                                            onSave: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                                setState(function (__x) {
                                                                      return MM_wrk_editor.completeDescrEditMode(__x, textNew);
                                                                    });
                                                              }),
                                                            onContinueEditing: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                              })
                                                          });
                                              }));
                                      }));
                                return ;
                              }
                            }),
                          editByAltClick: true,
                          renderer: (function (str) {
                              return React.createElement(Static_XML_to_HTML.make, {
                                          xmlStr: state.descr
                                        });
                            }),
                          fullWidth: true,
                          buttonDirHor: false,
                          onHelp: (function (param) {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(XML_formatting_help.make, {
                                                          onClose: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                            })
                        })
                  }));
  };
  var rndVars = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "7px",
                  marginLeft: "7px"
                },
                children: null
              }, "Variables", React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.varsText,
                        editMode: state.varsEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeVarsEditMode(__x, newText);
                                });
                          }),
                        onEditCancel: (function (newText) {
                            var textOld = state.varsText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          })
                      }), rndError(state.varsErr, "red")));
  };
  var rndDisj = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "7px",
                  marginLeft: "7px"
                },
                children: null
              }, "Disjoints", React.createElement(Expln_React_Column.make, {
                    children: null
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.disjText,
                        editMode: state.disjEditMode,
                        onEditRequested: (function (param) {
                            actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                          }),
                        onEditDone: (function (newText) {
                            setState(function (__x) {
                                  return MM_wrk_editor.completeDisjEditMode(__x, newText);
                                });
                          }),
                        onEditCancel: (function (newText) {
                            var textOld = state.disjText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          })
                      }), rndError(state.disjErr, "red")));
  };
  var rndStmts = function (param) {
    return React.createElement("table", undefined, React.createElement("tbody", undefined, state.stmts.map(rndStmt)));
  };
  return React.createElement(Expln_React_ContentWithStickyHeader.make, {
              top: top,
              header: rndButtons(undefined),
              content: (function (param) {
                  return React.createElement(Expln_React_Column.make, {
                              children: null
                            }, rndMainMenu(undefined), rndDescr(undefined), rndVars(undefined), rndDisj(undefined), rndStmts(undefined));
                })
            });
}

var make = MM_cmp_editor;

exports.unifyAllIsRequiredCnt = unifyAllIsRequiredCnt;
exports.editorSaveStateToLocStor = editorSaveStateToLocStor;
exports.readEditorStateFromLocStor = readEditorStateFromLocStor;
exports.rndIconButton = rndIconButton;
exports.stateLocStorKey = stateLocStorKey;
exports.lastUsedAsrtSearchTypLocStorKey = lastUsedAsrtSearchTypLocStorKey;
exports.saveLastUsedTyp = saveLastUsedTyp;
exports.getLastUsedTyp = getLastUsedTyp;
exports.make = make;
/* react Not a pure module */
